const defaultWait = ms => new Promise(resolve => window.setTimeout(resolve, ms));

export async function pollForStatusInformedInsight({
  fetchRecommendation,
  isDailyInsight,
  shouldContinue = () => true,
  wait = defaultWait,
  maxAttempts = 12,
  intervalMs = 5000,
}) {
  for (let attempt = 0; attempt < maxAttempts && shouldContinue(); attempt += 1) {
    const recommendation = await fetchRecommendation();
    if (isDailyInsight(recommendation)) return recommendation;
    if (attempt < maxAttempts - 1 && shouldContinue()) await wait(intervalMs);
  }
  return null;
}
